import React, { useState } from "react";
import { useSubmitContactMutation } from "../../store/contactApi";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./Contact.css";

const Contact = () => {
  const [submitContact, { isLoading, isSuccess, isError, error }] = useSubmitContactMutation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    rcsConsent: false,
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email address";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^[\d\s+-]{10,15}$/.test(formData.phone.replace(/\s/g, ""))) newErrors.phone = "Invalid phone number";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    if (!formData.rcsConsent) newErrors.rcsConsent = "Please agree to RCS terms to proceed";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitStatus(null);
    try {
      await submitContact({
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobile: formData.phone.trim(),
        message: formData.message.trim(),
        rcsConsent: formData.rcsConsent,
      }).unwrap();
      setSubmitStatus("success");
      setFormData({ name: "", email: "", phone: "", message: "", rcsConsent: false });
    } catch (err) {
      setSubmitStatus("error");
    }
  };

  return (
  <div className="contact-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner title="Contact Us" />

    <ScrollReveal variant="fadeUp">
    <div className="contact-heading-section">
      <h2 className="contact-heading">Get in Touch with Us</h2>
    </div>
    </ScrollReveal>

    <ScrollReveal variant="fadeUp" delay={0.1}>
    <div className="contact-cards-container">
      <div className="contact-cards-grid">
        {/* Email Card */}
        <div className="contact-card">
          <svg className="contact-card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <h3 className="contact-card-title">Email Us</h3>
          <div className="contact-card-content">
            <a href="mailto:nodal@pawansutholdings.com">nodal@pawansutholdings.com</a>
            {/* <a href="mailto:nodal@pawansutholdings.com">nodal@pawansutholdings.com</a> */}
          </div>
        </div>

        {/* Phone Card */}
        <div className="contact-card">
          <svg className="contact-card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <h3 className="contact-card-title">Call Us</h3>
          <div className="contact-card-content">
            <a href="tel:7428901149">+91 7428901149</a>
          </div>
        </div>

        {/* Address Card */}
        <div className="contact-card">
          <svg className="contact-card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <h3 className="contact-card-title">Visit Us</h3>
          <div className="contact-card-content">
            Floor No.: Third Floor of Back Portion<br />
            Building No./Flat No.: Property No. 5<br />
            Road/Street: Sant Nagar, Raja Dhir Sen Marg<br />
            Locality/Sub Locality: East of Kailash<br />
            City/Town/Village: New Delhi
          </div>
        </div>
      </div>
    </div>
    </ScrollReveal>

    {/* <ScrollReveal variant="fadeUp" delay={0.15}>
    <div className="enquiry-form-section">
      <div className="enquiry-form-container">
        <h3 className="enquiry-form-title">General Enquiry</h3>
        <form className="enquiry-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name <span className="required">*</span></label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
                className={errors.name ? "input-error" : ""}
              />
              {errors.name && <span className="error-text">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email <span className="required">*</span></label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number <span className="required">*</span></label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              className={errors.phone ? "input-error" : ""}
            />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="message">Message <span className="required">*</span></label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Enter your message"
              rows={5}
              className={errors.message ? "input-error" : ""}
            />
            {errors.message && <span className="error-text">{errors.message}</span>}
          </div>
          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="rcsConsent"
                checked={formData.rcsConsent}
                onChange={handleChange}
                className={errors.rcsConsent ? "input-error" : ""}
              />
              <span>I consent to receive regulatory/communication updates via RCS <span className="required">*</span></span>
            </label>
            {errors.rcsConsent && <span className="error-text">{errors.rcsConsent}</span>}
          </div>
          {submitStatus === "success" && (
            <div className="success-message">Thank you! Your enquiry has been submitted successfully. We will get back to you soon.</div>
          )}
          {submitStatus === "error" && (
            <div className="error-message">
              {error?.data?.message || error?.message || "Something went wrong. Please try again."}
            </div>
          )}
          <button type="submit" className="enquiry-submit-btn" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit Enquiry"}
          </button>
        </form>
      </div>
    </div>
    </ScrollReveal> */}

    <ScrollReveal variant="fadeUp" delay={0.1}>
    <div className="grievance-section">
      <div className="grievance-card">
        <div className="grievance-content">
          <div className="grievance-title">
            <span>🚨</span>
            <span>Grievance Redressal</span>
          </div>
          <div className="grievance-description">
            For any grievances, please contact us at:
          </div>
          <div className="grievance-contact">
            <div className="grievance-email">
              <a href="mailto:grievanceredressal@pawansutholdings.com">grievanceredressal@pawansutholdings.com</a>
            </div>
            <div className="grievance-phone">
              <a href="tel:7428901149">+91 7428901149</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </ScrollReveal>

    <ScrollReveal variant="fadeUp">
    <div className="map-container">
      <iframe
        title="Pawansut Holdings Limited Location"
        src="https://www.google.com/maps?q=Property+No.+5%2C+Third+Floor+of+Back+Portion%2C+Sant+Nagar%2C+Raja+Dhir+Sen+Marg%2C+East+of+Kailash%2C+New+Delhi&output=embed"
        width="100%"
        height="420"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
    </ScrollReveal>
  </div>
  );
};

export default Contact;
